import CleverPushApi from './api';
import { addPixelToStyle } from './utils/addPixelToStyle';
import CleverPushError from './error/CleverPushError';

export class CleverPushWidget {
  constructor() {
    this.config = {};
    this.api = null;

    if (window?.cleverpushConfig) {
      this.config = { ...window?.cleverpushConfig };
    } else if (window?.CleverPush) {
      this.config = { ...window.CleverPush.config };
    }
    if (this.config?.env === 'PREVIEW') {
      this.initializeWidgets();
    } else {
      this.api = new CleverPushApi(this.config?.channelId);

      this.api.getChannelConfig().then((config) => {
        this.config = config;

        this.initializeWidgets();
      }).catch((error) => {
        console.error('Failed to fetch channel config:', error);
      });
    }
  }

  initializeWidgets() {
    const widgetElements = document.querySelectorAll('.cleverpush-widget');

    widgetElements.forEach((widgetElement) => {
      const widgetId = widgetElement.getAttribute('data-id');
      const widgetType = widgetElement.dataset.widgetType;
      const widgetData = this.config.widgets?.find((widget) => widget._id === widgetId);

      if (widgetData && widgetType === 'whatsapp-widget') {
        this.appendWidgetData(widgetElement, widgetData, this.config?.whatsappPhoneNumber);
      } else {
        new CleverPushError(`Widget with ID "${widgetId}" not found in config.`);
      }
    });
  }

  appendWidgetData(widgetElement, widgetData, whatsappPhoneNumber = '') {
    const classNameId = `cleverpush-widget-${widgetData._id}`;
    const prefix = `.${classNameId}`;

    const style = document.createElement('style');
    style.innerHTML = `
    ${prefix} { ${addPixelToStyle({ ...(widgetData.style || {}) })} }
    ${prefix} .cleverpush-widget-image { ${addPixelToStyle(widgetData.imageStyle || {})} }
    ${prefix} .cleverpush-widget-content { ${addPixelToStyle(widgetData.contentStyle || {})} }
    ${prefix} .cleverpush-widget-title { ${addPixelToStyle(widgetData.titleStyle || {})} }
    ${prefix} .cleverpush-widget-text { ${addPixelToStyle(widgetData.textStyle || {})} }
    ${prefix} .cleverpush-widget-button-container { ${addPixelToStyle({ ...(widgetData.buttonStyle || {}), cursor: 'pointer' } || {})} }
    ${prefix} .cleverpush-widget-button-text { ${addPixelToStyle(widgetData.buttonTextStyle || {})} }
    @media (max-width: 767px) {
      ${prefix} {
        ${addPixelToStyle(widgetData.mobileStyle?.style || {})}
      }
      ${prefix} .cleverpush-widget-image {
        ${addPixelToStyle(widgetData.mobileStyle?.imageStyle || {})}
      }
      ${prefix} .cleverpush-widget-content {
        ${addPixelToStyle(widgetData.mobileStyle?.contentStyle || {})}
      }
      ${prefix} .cleverpush-widget-title {
        ${addPixelToStyle(widgetData.mobileStyle?.titleStyle || {})}
      }
      ${prefix} .cleverpush-widget-text {
        ${addPixelToStyle(widgetData.mobileStyle?.textStyle || {})}
      }
      ${prefix} .cleverpush-widget-button-container {
        ${addPixelToStyle(widgetData.mobileStyle?.buttonStyle || {})}
      }
    }
  `;

    document.head.appendChild(style);

    const container = `
      <div class="${classNameId}">
        <div>
          <img class="cleverpush-widget-image" src="${widgetData.imageUrl || 'https://example.com/default-image.png'}" />
        </div>
        <div class="cleverpush-widget-content">
          <div>
            <div class="cleverpush-widget-title">${widgetData.title || ''}</div>
            <div class="cleverpush-widget-text">${widgetData.text || ''}</div>
          </div>
          <a href="https://wa.me/${whatsappPhoneNumber}?text=START" class="cleverpush-widget-button-container">
            <div class="cleverpush-widget-button-text">${widgetData.buttonText || 'Submit'}</div>
            ${widgetData.iconUrl ? `<img src="${widgetData.iconUrl}" alt="Icon" />` : ''}
          </a>
        </div>
      </div>
    `;

    widgetElement.innerHTML += container;
  }
}
new CleverPushWidget();
